import styled from 'styled-components'

export const RecommendedPlansWrapper = styled.div`
  padding: 2rem 1rem;
  @media (min-width: 1024px) {
    padding: 73px 66px 50px 66px;
  }
`

export const Title = styled.h1`
  text-align: center;
  font-size: 45px;
`

export const Subtitle = styled.p`
  font-size: 1rem;
  text-align: center;
  margin-bottom: 40px;
`

export const Highlight = styled.span`
  color: var(--primary);
`

export const Action = styled.span`
  cursor: pointer;
  text-decoration: underline;
  font-weight: bold;
`
